const defaultFormatter = ({ shape })=>{
    return shape;
};

export { defaultFormatter };
